import { createAsyncThunk } from "@reduxjs/toolkit"

import { ErrorsActions } from "../../../Redux/redux/errors.slice"
import { handleApiError } from "../../../Utils/thunkHelpers"
import * as services from "../services"
import { ADMIN_USERS_SLICE_NAME } from "./adminUsers.constants"

export const getAdminUsers = createAsyncThunk(
  `${ADMIN_USERS_SLICE_NAME}/get_admin_users`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getAdminUsers(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getAdminUsersCount = createAsyncThunk(
  `${ADMIN_USERS_SLICE_NAME}/get_admin_users_count`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getAdminUsersCount(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getAdminUsersInviteRoles = createAsyncThunk(
  `${ADMIN_USERS_SLICE_NAME}/get_admin_users_invite_roles`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getAdminUsersInviteRoles(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getAdminUsersExport = createAsyncThunk(
  `${ADMIN_USERS_SLICE_NAME}/get_admin_users_export`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getAdminUsersExport(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const updateAdminUserRole = createAsyncThunk(
  `${ADMIN_USERS_SLICE_NAME}/update_admin_user_role`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.updateAdminUserRole(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const inviteAdminUser = createAsyncThunk(
  `${ADMIN_USERS_SLICE_NAME}/invite_admin_user`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.inviteAdminUser(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const resendAdminUserInvite = createAsyncThunk(
  `${ADMIN_USERS_SLICE_NAME}/resend_admin_user_invite`,
  async (id, { dispatch, rejectWithValue }) => {
    const response = await services.resendAdminUserInvite(id)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

// Legacy `deleteAdminUserSaga` was a bespoke saga (not routed through apiGeneratorBase) with its
// own error handling: it wraps the raw response body as `{ message: response.data }` instead of
// extracting a nested detail string, so it's kept verbatim rather than swapped for
// `handleApiError` (which does the detail-extraction apiGeneratorBase used elsewhere).
export const deleteAdminUser = createAsyncThunk(
  `${ADMIN_USERS_SLICE_NAME}/delete_admin_user`,
  async (id, { dispatch, rejectWithValue }) => {
    const response = await services.deleteAdminUser(id)
    if (!response.ok) {
      dispatch(
        ErrorsActions.errorSave(
          response.status === 500 ? "Server response error" : { message: response.data }
        )
      )
      return rejectWithValue(response.data)
    }
    return response.data || id
  }
)
